<template>
    <article class="map-modal">
        <div
            v-if="isLoading"
            class="map-modal__loader">
            <svg xmlns="http://www.w3.org/2000/svg" width="100" height="100">
                <circle cx="50" cy="50" r="32" stroke-width="5" stroke="#1c1b28" stroke-dasharray="50.26548245743669 50.26548245743669" fill="none" stroke-linecap="round"/>
            </svg>
        </div>
        <div
            v-if="mapModalData"
            class="map-modal__container">
            <button
                class="map-modal__close"
                aria-label="Закрыть модальное окно"
                @click.prevent="$emit('closeMapModal')"></button>
            <div
                v-if="mapModalData.data.props.lot_status || mapModalData.data.props.condition"
                class="map-modal__labels">
                <div
                    v-if="mapModalData.data.props.lot_status === 'announced'"
                    class="map-modal__auction">
                    Объявленный аукцион
                </div>
                <div
                    v-if="mapModalData.data.props.lot_status === 'planned'"
                    class="map-modal__auction map-modal__auction--planned">
                    Планируемый аукцион
                </div>
                <div
                    v-if="mapModalData.data.props.condition"
                    class="map-modal__condition">
                    <span>С обременением</span>
                    <div class="map-modal__tooltip">
                        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
                            <g clip-path="url(#clip0_1326_30231)">
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M0.583984 6.99967C0.583984 10.5435 3.45682 13.4163 7.00065 13.4163C10.5445 13.4163 13.4173 10.5435 13.4173 6.99967C13.4173 3.45585 10.5445 0.583008 7.00065 0.583008C3.45682 0.583008 0.583984 3.45585 0.583984 6.99967ZM12.2506 6.99969C12.2506 9.89918 9.90014 12.2497 7.00064 12.2497C4.10115 12.2497 1.75064 9.89918 1.75064 6.99969C1.75064 4.10019 4.10115 1.74969 7.00064 1.74969C9.90014 1.74969 12.2506 4.10019 12.2506 6.99969Z" fill="#252628"/>
                                <path d="M6.53211 8.17602C6.53211 7.93968 6.58283 7.71945 6.68428 7.51534C6.78573 7.31123 6.90854 7.13666 7.0527 6.99163C7.19687 6.8466 7.34103 6.70963 7.4852 6.58072C7.62936 6.44643 7.75217 6.30141 7.85362 6.14564C7.95507 5.98449 8.00579 5.81529 8.00579 5.63804C8.00579 5.36947 7.91235 5.16536 7.72547 5.0257C7.54393 4.88067 7.30633 4.80816 7.01266 4.80816C6.42532 4.80816 6.04889 5.06867 5.88337 5.5897L5.25064 5.23518C5.38413 4.85919 5.61106 4.5745 5.93142 4.38113C6.25179 4.18239 6.61487 4.08302 7.02067 4.08302C7.49588 4.08302 7.90167 4.2173 8.23806 4.48587C8.57978 4.75444 8.75064 5.12776 8.75064 5.60581C8.75064 5.83141 8.69992 6.04358 8.59847 6.24232C8.49702 6.44106 8.37422 6.61295 8.23005 6.75797C8.08589 6.903 7.94172 7.04534 7.79756 7.185C7.65339 7.31928 7.53058 7.47237 7.42913 7.64425C7.32768 7.81077 7.27696 7.98802 7.27696 8.17602H6.53211ZM6.90053 9.91635C6.75637 9.91635 6.63356 9.86532 6.53211 9.76327C6.43066 9.66121 6.37994 9.53767 6.37994 9.39264C6.37994 9.24761 6.43066 9.12407 6.53211 9.02202C6.63356 8.91996 6.75637 8.86893 6.90053 8.86893C7.05003 8.86893 7.17284 8.91996 7.26895 9.02202C7.3704 9.12407 7.42112 9.24761 7.42112 9.39264C7.42112 9.53767 7.3704 9.66121 7.26895 9.76327C7.17284 9.86532 7.05003 9.91635 6.90053 9.91635Z" fill="#252628"/>
                            </g>
                            <defs>
                                <clipPath id="clip0_1326_30231">
                                <rect width="14" height="14" fill="white"/>
                                </clipPath>
                            </defs>
                        </svg>
                        <div class="map-modal__tooltip-text">
                            Объекты, в которых зарегистрированы и/или проживают третьи лица. Такие объекты реализуются со скидкой.
                        </div>
                    </div>
                </div>
            </div>
            <a
                class="map-modal__area-link"
                :href="mapModalData.data.link">
                <div
                    class="map-modal__type"
                    v-html="mapModalData.data.props.object_type_ru"></div>
                <div
                    v-if="mapModalData.data.props.price"
                    class="map-modal__prices">
                    <div
                        v-if="mapModalData.data.props.price"
                        class="map-modal__price">
                        {{ formatNumbers(mapModalData.data.props.price) }} ₽
                    </div>
                    <div
                        v-if="mapModalData.data.props.old_price"
                        class="map-modal__old-price">
                        {{ formatNumbers(mapModalData.data.props.old_price) }} ₽
                    </div>
                    <div
                        v-if="mapModalData.data.props.rub_per_sqm"
                        class="map-modal__price-per-meter">
                        {{ formatNumbers(mapModalData.data.props.rub_per_sqm) }} ₽/м²
                    </div>
                </div>
                <address
                    class="map-modal__address"
                    v-html="mapModalData.data.name"></address>
                <div
                    v-if="mapModalData.data.props.auction_date || mapModalData.data.props.auction_deadline"
                    class="map-modal__dates">
                    <div
                        v-if="mapModalData.data.props.auction_deadline"
                        class="map-modal__date">
                        <div class="map-modal__date-label">
                            Окончание приема заявок:
                        </div>
                        <div
                            class="map-modal__date-time"
                            v-html="mapModalData.data.props.auction_deadline"></div>
                    </div>
                    <div
                        v-if="mapModalData.data.props.auction_date"
                        class="map-modal__date">
                        <div class="map-modal__date-label">
                            Проведение торгов:
                        </div>
                        <div
                            class="map-modal__date-time"
                            v-html="mapModalData.data.props.auction_date"></div>
                    </div>
                </div>
                <ul
                    v-if="mapModalData.data.props.rooms || mapModalData.data.props.floor || mapModalData.data.props.area || mapModalData.data.props.section_area"
                    class="map-modal__options">
                    <li
                        v-if="mapModalData.data.props.rooms"
                        class="map-modal__option map-modal__option--rooms">
                        {{ `${mapModalData.data.props.rooms} ${formatWordOfNum(mapModalData.data.props.rooms, ['комната', 'комнаты', 'комнат'])}` }}
                    </li>
                    <li
                        v-if="mapModalData.data.props.area"
                        class="map-modal__option map-modal__option--space">
                        {{ mapModalData.data.props.area }} м²
                    </li>
                    <li
                        v-if="mapModalData.data.props.floor"
                        class="map-modal__option map-modal__option--floor">
                        {{ getFloorsLabel(mapModalData.data.props.object_type, mapModalData.data.props.floor, mapModalData.data.props.floors_count) }}
                    </li>
                    <li
                        v-if="mapModalData.data.props.section_area"
                        class="map-modal__option map-modal__option--area">
                        {{ formatNumbers(mapModalData.data.props.section_area) }} м²
                    </li>
                </ul>
            </a>
            <div class="map-modal__buttons">
                <a
                    class="map-modal__link map-modal__link--black"
                    href="#"
                    title="Задать вопрос"
                    @click.prevent="$emit('showForm', mapModalData.data)">
                    Задать вопрос
                </a>
                <a
                    v-if="!isMobile"
                    class="map-modal__link"
                    :href="mapModalData.data.link"
                    title="Подробнее">
                    Подробнее
                </a>
            </div>
        </div>
        
    </article>
</template>

<script>
    import declineWordOfNum from '../../../modules/decline-word-of-num.js'

    export default {
        name: 'MapModal',
        props: {
            mapModalData: {
                type: Object,
                default: () => {}
            },
            isLoading: {
                type: Boolean,
                default: false
            }
        },
        computed: {
            isMobile() {
                return typeof window === 'object' && window.innerWidth < 768
            }
        },
        methods: {
            formatNumbers (number) {
                return new Intl.NumberFormat("ru-RU").format(number)
            },
            
            formatWordOfNum (num, textArr) {
                return declineWordOfNum(num, textArr)
            },

            getFloorsLabel(type, floor, floormax) {
                if (type === 'FLAT') {
                    return `${floor}/${floormax} этаж`
                }

                if (!type) {
                    return `${floor} этаж`
                }

                return `${floormax} ${this.formatWordOfNum(floormax, ['этаж', 'этажа', 'этажей'])}`
            }
        },
    }
</script>